import React, { useState } from "react";
import "./tabs.css";
// タブページ
import HomePageTab from "./HomePage";
import GraphicDesignTab from "./GraphicDesign";

const Tabs = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const handleClick = (index) => setActiveIndex(index);
  const checkActive = (index, className) =>
    activeIndex === index ? className : "";
  return (
    <>
      <div className="tabs one-only">
        <button
          className={`tab ${checkActive(1, "active")}`}
          onClick={() => handleClick(1)}
        >
          WEB制作
        </button>
        {/* <button
          className={`tab ${checkActive(2, "active")}`}
          onClick={() => handleClick(2)}
        >
          グラフィックデザイン
        </button> */}
      </div>
      <div className="panels">
        <div className={`panel ${checkActive(1, "active")}`}>
          <HomePageTab />
        </div>
        <div className={`panel ${checkActive(2, "active")}`}>
          <GraphicDesignTab />
        </div>
      </div>
    </>
  );
};

export default Tabs;
